import { ActionIcon, Group } from '@mantine/core';
import { IconMenu2 } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';

import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';
import { useDevices } from 'utils/devices';

import Profile from './Profile';
import NotificationsButton from './UserNotificationsButton';

import s from './Header.module.scss';

type Props = {
  withBottomPadding?: boolean;
  className?: string;
};

const Header: React.FC<Props> = ({ withBottomPadding = true, className }) => {
  const { isPhone } = useDevices();
  const { menu } = useLkLayoutStore();

  return (
    <Group className={cn(s.root, withBottomPadding && s['root_with-bottom-padding'], className)} align="center">
      {isPhone && (
        <ActionIcon variant="light" size={36} onClick={menu.open}>
          <IconMenu2 size={20} />
        </ActionIcon>
      )}
      <div id="header-portal" className={s.root__portal}></div>

      <Group align="center" gap="xxxs">
        <NotificationsButton />
        <Profile />
      </Group>
    </Group>
  );
};

export default React.memo(Header);
